import React from 'react'

function SkipButton() {
  return (
    <div className='SkipToContent'>
        <a href="#GallerySection" className="skipButton">skip to content</a>
    </div>
  )
}

export default SkipButton